import React, { useState, useEffect } from 'react';
import { Play, X, Users, Clock, Shield, Ruler, Weight, Zap, Star, Heart, Sparkles } from 'lucide-react';

function Gallery() {
  const [loadedVideos, setLoadedVideos] = useState<{ [key: string]: boolean }>({});
  const [selectedAttraction, setSelectedAttraction] = useState<number | null>(null);
  const [isMobile, setIsMobile] = useState(false);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [selectedCategory, setSelectedCategory] = useState<string>('Tutte');

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 768);
    };
    
    checkMobile();
    window.addEventListener('resize', checkMobile);
    
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  const attractions = [
    {
      videoUrl: 'https://radioflashmusic1.altervista.org/tagadagif.mp4',
      category: 'Giostre Adrenaliniche',
      images: [
        'https://radioflashmusic1.altervista.org/valentinaeventi/tagada/tagada.jpg',
        'https://radioflashmusic1.altervista.org/valentinaeventi/tagada/tagada1.jpg',
        'https://radioflashmusic1.altervista.org/valentinaeventi/tagada/tagada2.jpg',
        'https://radioflashmusic1.altervista.org/valentinaeventi/tagada/tagada3.jpg'
      ],
      mobileGif: 'https://radioflashmusic1.altervista.org/valentinaeventi/tagada.gif',
      fallbackImage: 'https://radioflashmusic1.altervista.org/valentinaeventi/tagada.jpg',
      alt: 'Tagada',
      title: 'Tagada',
      description: 'L\'attrazione regina del divertimento, per momenti indimenticabili di pura adrenalina',
      features: [
          'Effetti luminosi spettacolari',
          'Sistema audio professionale',
          'Movimenti sincronizzati',
          'Esperienza adrenalinica unica'
        ],
      rating: 5,
      ageRange: '12+',
      capacity: '24 persone',
      duration: '3-5 min'
    },
    {
      previewGif: 'https://radioflashmusic1.altervista.org/valentinaeventi/dischivolanti/dischivolanti.jpg',
      category: 'Giostre Classiche',
      images: [
        'https://radioflashmusic1.altervista.org/valentinaeventi/dischivolanti/dischivolanti.jpg',
        'https://radioflashmusic1.altervista.org/valentinaeventi/dischivolanti/dischivolanti1.jpg',
        'https://radioflashmusic1.altervista.org/valentinaeventi/dischivolanti/dischivolanti2.jpg',
        'https://radioflashmusic1.altervista.org/valentinaeventi/dischivolanti/dischivolanti3.jpg'
      ],
      fullGif: 'https://radioflashmusic1.altervista.org/valentinaeventi/dischivolanti/dischivolanti.jpg',
      mobileGif: 'https://radioflashmusic1.altervista.org/valentinaeventi/dischivolanti/dischivolanti.jpg',
      fallbackImage: 'https://radioflashmusic1.altervista.org/valentinaeventi/dischivolanti/dischivolanti.jpg',
      alt: 'Giostra Avio',
      title: 'Giostra Avio',
      description: 'Un viaggio magico tra le stelle, per sognare ad occhi aperti',
      features: [
          'Spettacolo di luci mozzafiato',
          'Esperienza immersiva totale',
          'Musica envolvente',
          'Movimenti fluidi e armoniosi'
        ],
      rating: 4.8,
      ageRange: '8+',
      capacity: '16 persone',
      duration: '4-6 min'
    },
    {
      previewGif: 'https://radioflashmusic1.altervista.org/valentinaeventi/trenino-preview.gif',
      category: 'Giostre per Bambini',
      images: [
        'https://radioflashmusic1.altervista.org/valentinaeventi/trenino/trenino.jpg',
        'https://radioflashmusic1.altervista.org/valentinaeventi/trenino/trenino1.jpg',
        'https://radioflashmusic1.altervista.org/valentinaeventi/trenino/trenino2.jpg',
        'https://radioflashmusic1.altervista.org/valentinaeventi/trenino/trenino3.jpg'
      ],
      fullGif: 'https://radioflashmusic1.altervista.org/valentinaeventi/trenino-full.gif',
      mobileGif: 'https://radioflashmusic1.altervista.org/valentinaeventi/trenino.gif',
      fallbackImage: 'https://radioflashmusic1.altervista.org/trenino.jpg',
      alt: 'Trenino Magico',
      title: 'Trenino Magico',
      description: 'Un\'avventura fantastica nel mondo delle fiabe per tutta la famiglia',
      features: [
          'Ambientazione fiabesca',
          'Effetti magici interattivi',
          'Musiche incantate',
          'Decorazioni fantastiche'
        ],
      rating: 4.9,
      ageRange: '3+',
      capacity: '12 bambini',
      duration: '5-7 min'
    },
    {
      videoUrl: 'https://radioflashmusic1.altervista.org/valentinaeventi/miniseggiolini/minisegiolini.mp4',
      previewGif: 'https://radioflashmusic1.altervista.org/valentinaeventi/miniseggiolini/miniseggiolini.jpg',
      category: 'Giostre per Bambini',
      images: [
        'https://radioflashmusic1.altervista.org/valentinaeventi/miniseggiolini/miniseggiolini.jpg',
        'https://radioflashmusic1.altervista.org/valentinaeventi/miniseggiolini/miniseggiolini1.jpg',
        'https://radioflashmusic1.altervista.org/valentinaeventi/miniseggiolini/miniseggiolini2.jpg',
        'https://radioflashmusic1.altervista.org/valentinaeventi/miniseggiolini/miniseggiolini3.jpg'
      ],
      fullGif: 'https://radioflashmusic1.altervista.org/valentinaeventi/miniseggiolini/miniseggiolini.jpg',
      mobileGif: 'https://radioflashmusic1.altervista.org/valentinaeventi/miniseggiolini/miniseggiolini.jpg',
      fallbackImage: 'https://radioflashmusic1.altervista.org/valentinaeventi/miniseggiolini/miniseggiolini.jpg',
      alt: 'Mini Seggiolini',
      title: 'Mini Seggiolini',
      description: 'Una giostra dolce e sicura per i più piccoli, perfetta per il loro divertimento',
      features: [
          'Movimento dolce e controllato',
          'Luci colorate a LED',
          'Musica per bambini',
          'Sedili ergonomici e sicuri'
        ],
      rating: 4.7,
      ageRange: '2-8 anni',
      capacity: '8 bambini',
      duration: '3-4 min'
    },
    {
      previewGif: 'https://images.unsplash.com/photo-1597466599360-3b9775841aec',
      images: [
        'https://images.unsplash.com/photo-1597466599360-3b9775841aec',
        'https://images.unsplash.com/photo-1597466599360-3b9775841aec',
        'https://images.unsplash.com/photo-1597466599360-3b9775841aec',
        'https://images.unsplash.com/photo-1597466599360-3b9775841aec'
      ],
      fullGif: 'https://images.unsplash.com/photo-1597466599360-3b9775841aec',
      mobileGif: 'https://images.unsplash.com/photo-1597466599360-3b9775841aec',
      fallbackImage: 'https://images.unsplash.com/photo-1597466599360-3b9775841aec',
      category: 'Giostre Classiche',
      alt: 'Seggiolini per Adulti',
      title: 'Seggiolini per Adulti',
      description: 'L\'intramontabile classico del divertimento per tutte le età',
      features: [
          'Illuminazione LED programmabile',
          'Sistema audio digitale',
          'Sedili confortevoli',
          'Velocità regolabile'
        ],
      rating: 4.6,
      ageRange: '10+',
      capacity: '20 persone',
      duration: '4-5 min'
    },
    {
      previewGif: 'https://images.unsplash.com/photo-1597466599360-3b9775841aec',
      images: [
        'https://images.unsplash.com/photo-1597466599360-3b9775841aec',
        'https://images.unsplash.com/photo-1597466599360-3b9775841aec',
        'https://images.unsplash.com/photo-1597466599360-3b9775841aec',
        'https://images.unsplash.com/photo-1597466599360-3b9775841aec'
      ],
      fullGif: 'https://images.unsplash.com/photo-1597466599360-3b9775841aec',
      mobileGif: 'https://images.unsplash.com/photo-1597466599360-3b9775841aec',
      fallbackImage: 'https://images.unsplash.com/photo-1597466599360-3b9775841aec',
      category: 'Giostre per Bambini',
      alt: 'Mini Autoscontro',
      title: 'Mini Autoscontro',
      description: 'Divertimento sicuro con piccole auto elettriche per i più piccoli',
      features: [
          'Auto colorate e sicure',
          'Pista illuminata',
          'Velocità limitata',
          'Pavimento ammortizzato'
        ],
      rating: 4.8,
      ageRange: '4-12 anni',
      capacity: '6 auto',
      duration: '5 min'
    },
    {
      previewGif: 'https://images.unsplash.com/photo-1597466599360-3b9775841aec',
      images: [
        'https://images.unsplash.com/photo-1597466599360-3b9775841aec',
        'https://images.unsplash.com/photo-1597466599360-3b9775841aec',
        'https://images.unsplash.com/photo-1597466599360-3b9775841aec',
        'https://images.unsplash.com/photo-1597466599360-3b9775841aec'
      ],
      fullGif: 'https://images.unsplash.com/photo-1597466599360-3b9775841aec',
      mobileGif: 'https://images.unsplash.com/photo-1597466599360-3b9775841aec',
      fallbackImage: 'https://images.unsplash.com/photo-1597466599360-3b9775841aec',
      category: 'Gonfiabili',
      alt: 'Gonfiabili',
      title: 'Gonfiabili',
      description: 'Una vasta gamma di gonfiabili per ogni età e occasione',
      features: [
          'Diverse dimensioni disponibili',
          'Temi personalizzabili',
          'Materiali certificati',
          'Facile installazione'
        ],
      rating: 4.5,
      ageRange: '3-12 anni',
      capacity: 'Variabile',
      duration: 'Tutto il giorno'
    },
    {
      previewGif: 'https://images.unsplash.com/photo-1597466599360-3b9775841aec',
      images: [
        'https://images.unsplash.com/photo-1597466599360-3b9775841aec',
        'https://images.unsplash.com/photo-1597466599360-3b9775841aec',
        'https://images.unsplash.com/photo-1597466599360-3b9775841aec',
        'https://images.unsplash.com/photo-1597466599360-3b9775841aec'
      ],
      fullGif: 'https://images.unsplash.com/photo-1597466599360-3b9775841aec',
      mobileGif: 'https://images.unsplash.com/photo-1597466599360-3b9775841aec',
      fallbackImage: 'https://images.unsplash.com/photo-1597466599360-3b9775841aec',
      category: 'Attrazioni Speciali',
      alt: 'Tappeti Elastici',
      title: 'Tappeti Elastici',
      description: 'Divertimento assicurato con i nostri tappeti elastici professionali',
      features: [
          'Diverse dimensioni disponibili',
          'Reti di protezione alte',
          'Molle di sicurezza coperte',
          'Struttura rinforzata'
        ],
      rating: 4.7,
      ageRange: '5+',
      capacity: '4-8 persone',
      duration: 'Sessioni da 10 min'
    }
  ];

  // Get unique categories
  const categories = ['Tutte', ...Array.from(new Set(attractions.map(attraction => attraction.category)))];

  // Filter attractions by selected category
  const filteredAttractions = selectedCategory === 'Tutte' 
    ? attractions 
    : attractions.filter(attraction => attraction.category === selectedCategory);

  const handleAttractionClick = (index: number) => {
    setSelectedAttraction(index);
    document.body.style.overflow = 'hidden';
    document.documentElement.classList.add('modal-open');
  };

  const closeModal = () => {
    setSelectedAttraction(null);
    document.body.style.overflow = 'auto';
    document.documentElement.classList.remove('modal-open');
  };

  const renderStars = (rating: number) => {
    return Array.from({ length: 5 }, (_, i) => (
      <Star
        key={i}
        className={`h-4 w-4 ${
          i < Math.floor(rating) 
            ? 'text-yellow-400 fill-current' 
            : i < rating 
            ? 'text-yellow-400 fill-current opacity-50' 
            : 'text-gray-300'
        }`}
      />
    ));
  };

  return (
    <div id="galleria" className="py-32 bg-gradient-to-b from-white via-pink-50/50 to-white relative overflow-hidden min-h-screen">
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_top_left,_var(--tw-gradient-stops))] from-pink-200/20 via-transparent to-transparent"></div>
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_bottom_right,_var(--tw-gradient-stops))] from-purple-200/20 via-transparent to-transparent"></div>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center">
          <div className="inline-block relative mb-8">
            <span className="absolute -inset-8 bg-gradient-to-r from-pink-600/40 to-purple-600/40 blur-2xl rounded-full animate-pulse hidden sm:block"></span>
            <span className="absolute -inset-12 bg-gradient-to-r from-pink-400/30 to-purple-400/30 blur-3xl rounded-full animate-pulse hidden sm:block" style={{ animationDelay: '0.5s' }}></span>
            <h2 className="relative text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-black tracking-tight gradient-text-animated px-4 sm:px-0 drop-shadow-sm">
            Scopri le Nostre Attrazioni
            </h2>
          </div>
          <p className="mt-4 text-base sm:text-lg md:text-xl text-gray-600 max-w-2xl mx-auto px-4 sm:px-0 leading-relaxed">
            Un mondo di divertimento per rendere indimenticabile ogni evento
          </p>
          
          {/* Enhanced Category Filter */}
          <div className="mt-8 flex flex-wrap justify-center gap-2 sm:gap-4">
            {categories.map((category) => (
              <button
                key={category}
                onClick={() => setSelectedCategory(category)}
                className={`inline-flex items-center px-4 sm:px-6 py-2 sm:py-3 rounded-full text-sm sm:text-base font-medium transition-all duration-300 hover:scale-105 ${
                  selectedCategory === category
                    ? 'bg-gradient-to-r from-pink-600 to-purple-600 text-white shadow-lg hover:shadow-xl'
                    : 'bg-gradient-to-r from-pink-50 to-purple-50 text-pink-600 border border-pink-100 hover:border-pink-300 hover:shadow-lg'
                }`}
              >
                {category}
                {selectedCategory === category && (
                  <Sparkles className="ml-2 h-4 w-4 animate-pulse" />
                )}
              </button>
            ))}
          </div>

          {/* Stats Bar */}
          <div className="mt-8 flex flex-wrap justify-center gap-4 sm:gap-8">
            <div className="flex items-center space-x-2 text-gray-600">
              <Heart className="h-5 w-5 text-pink-500" />
              <span className="text-sm font-medium">{filteredAttractions.length} Attrazioni</span>
            </div>
            <div className="flex items-center space-x-2 text-gray-600">
              <Shield className="h-5 w-5 text-green-500" />
              <span className="text-sm font-medium">100% Sicure</span>
            </div>
            <div className="flex items-center space-x-2 text-gray-600">
              <Star className="h-5 w-5 text-yellow-500" />
              <span className="text-sm font-medium">Qualità Premium</span>
            </div>
          </div>
        </div>

        {/* Enhanced Attractions Grid */}
        <div className="mt-12 sm:mt-16 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8 px-4 sm:px-0">
          {filteredAttractions.map((attraction, index) => (
            <div 
              key={index} 
              className="group relative overflow-hidden rounded-3xl animate-float bg-white/95 backdrop-blur-sm shadow-lg hover:shadow-2xl transition-all duration-500 hover:-translate-y-2 hover:rotate-1 border border-pink-100/50 hover:border-pink-200 cursor-pointer"
              style={{ animationDelay: `${index * 0.1}s` }}
              onClick={() => handleAttractionClick(index)}
            >
              <div className="relative aspect-[4/3] overflow-hidden">
                {isMobile ? (
                  <img
                    src={attraction.mobileGif}
                    alt={attraction.alt}
                    className="absolute inset-0 w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                    onError={(e) => {
                      e.currentTarget.src = attraction.fallbackImage;
                    }}
                  />
                ) : (
                  <img
                    src={index === 0 ? attraction.fallbackImage : attraction.previewGif}
                    alt={attraction.alt}
                    className="absolute inset-0 w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                    onError={(e) => {
                      e.currentTarget.src = attraction.fallbackImage;
                    }}
                  />
                )}
                
                {/* Category Badge */}
                <div className="absolute top-4 left-4 px-3 py-1 bg-white/90 backdrop-blur-sm rounded-full text-xs font-medium text-pink-600 border border-pink-100">
                  {attraction.category}
                </div>

                {/* Rating Badge */}
                <div className="absolute top-4 right-4 flex items-center space-x-1 px-2 py-1 bg-white/90 backdrop-blur-sm rounded-full">
                  <Star className="h-3 w-3 text-yellow-400 fill-current" />
                  <span className="text-xs font-medium text-gray-700">{attraction.rating}</span>
                </div>

                {/* Play Button Overlay */}
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  <div className="absolute inset-0 flex items-center justify-center">
                    <div className="transform -translate-y-4 group-hover:translate-y-0 transition-all duration-300">
                      <div className="w-16 h-16 bg-gradient-to-r from-pink-600/90 to-purple-600/90 backdrop-blur-sm rounded-full flex items-center justify-center border border-white/50 group-hover:scale-110 transition-all duration-300 hover:border-pink-400 shadow-lg hover:shadow-xl">
                        <Play className="w-6 h-6 text-white fill-current ml-1" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Enhanced Content */}
              <div className="p-6">
                <div className="flex items-start justify-between mb-3">
                  <h3 className="text-xl font-bold text-gray-900 group-hover:text-pink-600 transition-colors duration-300">
                    {attraction.title}
                  </h3>
                  <div className="flex items-center space-x-1">
                    {renderStars(attraction.rating)}
                  </div>
                </div>
                
                <p className="text-gray-600 text-sm leading-relaxed mb-4">
                  {attraction.description}
                </p>

                {/* Quick Info */}
                <div className="grid grid-cols-2 gap-3 mb-4 text-xs">
                  <div className="flex items-center space-x-2 text-gray-500">
                    <Users className="h-4 w-4 text-pink-500" />
                    <span>{attraction.capacity}</span>
                  </div>
                  <div className="flex items-center space-x-2 text-gray-500">
                    <Clock className="h-4 w-4 text-blue-500" />
                    <span>{attraction.duration}</span>
                  </div>
                  <div className="flex items-center space-x-2 text-gray-500">
                    <Shield className="h-4 w-4 text-green-500" />
                    <span>Età: {attraction.ageRange}</span>
                  </div>
                  <div className="flex items-center space-x-2 text-gray-500">
                    <Zap className="h-4 w-4 text-yellow-500" />
                    <span>Certificata CE</span>
                  </div>
                </div>

                {/* Action Button */}
                <button className="w-full inline-flex items-center justify-center px-4 py-3 text-sm font-medium rounded-xl text-white bg-gradient-to-r from-pink-600 to-purple-600 hover:from-pink-700 hover:to-purple-700 transform hover:scale-102 transition-all duration-300 shadow-lg hover:shadow-xl group-hover:shadow-pink-500/25">
                  Scopri di più
                  <svg className="w-4 h-4 ml-2 transform group-hover:translate-x-1 transition-transform duration-300" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M5 12h14M12 5l7 7-7 7"/>
                  </svg>
                </button>
              </div>
            </div>
          ))}
        </div>

        {/* Modal */}
        {selectedAttraction !== null && (
          <div className="modal-container" aria-labelledby="modal-title" role="dialog" aria-modal="true">
            <div className="flex items-center justify-center min-h-screen px-4 py-6 text-center sm:p-0">
              <div className="fixed inset-0 bg-gray-900/75 backdrop-blur-sm transition-opacity" aria-hidden="true" onClick={closeModal}>
                <div className="absolute inset-0 bg-gradient-to-br from-pink-900/20 to-purple-900/20"></div>
              </div>
              <span className="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">&#8203;</span>
              <div className="modal-content inline-block align-bottom text-left sm:my-8 sm:align-middle sm:max-w-4xl w-full max-h-[90vh] overflow-y-auto modal-scroll mx-auto">
                <div className="absolute top-0 right-0 pt-4 pr-4 z-10">
                  <button
                    type="button"
                    className="bg-white/10 backdrop-blur-sm rounded-full p-2 text-white hover:text-pink-100 focus:outline-none hover:bg-white/20 transition-all duration-300 hover:scale-110"
                    onClick={closeModal}
                  >
                    <span className="sr-only">Chiudi</span>
                    <X className="h-6 w-6" />
                  </button>
                </div>
                <div className="bg-white/95 backdrop-blur-xl">
                  <div className="relative aspect-video sm:aspect-[16/9]">
                    {attractions[selectedAttraction].videoUrl ? (
                      <video
                        autoPlay
                        muted
                        loop
                        playsInline
                        className="w-full h-full object-cover transform-gpu"
                        onError={(e) => {
                          const target = e.target as HTMLVideoElement;
                          target.src = attractions[selectedAttraction].fallbackImage;
                        }}
                      >
                        <source src={attractions[selectedAttraction].videoUrl} type="video/mp4" />
                        Il tuo browser non supporta i video HTML5.
                      </video>
                    ) : (
                      <img
                        src={attractions[selectedAttraction].fullGif}
                        alt={attractions[selectedAttraction].alt}
                        className="w-full h-full object-cover transform-gpu"
                        onError={(e) => {
                          e.currentTarget.src = attractions[selectedAttraction].fallbackImage;
                        }}
                      />
                    )}
                    <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent"></div>
                    <div className="absolute bottom-0 left-0 right-0 p-4 sm:p-6 md:p-8">
                      <div className="flex items-center justify-between mb-4">
                        <div>
                          <h3 className="text-2xl sm:text-3xl font-bold text-white mb-2 tracking-wide">{attractions[selectedAttraction].title}</h3>
                          <p className="text-base sm:text-xl text-white/95">{attractions[selectedAttraction].description}</p>
                        </div>
                        <div className="flex items-center space-x-1 bg-white/20 backdrop-blur-sm rounded-full px-3 py-1">
                          {renderStars(attractions[selectedAttraction].rating)}
                          <span className="ml-2 text-white font-medium">{attractions[selectedAttraction].rating}</span>
                        </div>
                      </div>
                      <div className="flex flex-wrap gap-3">
                        <span className="inline-flex items-center px-4 py-1.5 rounded-full text-sm font-medium bg-white/20 backdrop-blur-sm text-white border border-white/30 hover:bg-white/30 transition-colors duration-300">
                          <Clock className="w-4 h-4 mr-1.5" />
                          {attractions[selectedAttraction].duration}
                        </span>
                        <span className="inline-flex items-center px-4 py-1.5 rounded-full text-sm font-medium bg-white/20 backdrop-blur-sm text-white border border-white/30 hover:bg-white/30 transition-colors duration-300">
                          <Users className="w-4 h-4 mr-1.5" />
                          {attractions[selectedAttraction].capacity}
                        </span>
                        <span className="inline-flex items-center px-4 py-1.5 rounded-full text-sm font-medium bg-white/20 backdrop-blur-sm text-white border border-white/30 hover:bg-white/30 transition-colors duration-300">
                          <Shield className="w-4 h-4 mr-1.5" />
                          Età: {attractions[selectedAttraction].ageRange}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="p-4 sm:p-6 md:p-8">
                    <div className="space-y-8">
                      <h4 className="text-xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-pink-600 to-purple-600 mb-4">
                        Caratteristiche Speciali
                      </h4>
                      <ul className="grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-4 mb-6 sm:mb-8">
                        {attractions[selectedAttraction].features.map((feature, index) => (
                          <li key={index} className="group flex items-center p-4 bg-gradient-to-br from-white to-pink-50/30 rounded-xl shadow-sm border border-pink-100/50 hover:shadow-md transition-all duration-300 hover:scale-102">
                            <div className="w-10 h-10 bg-gradient-to-r from-pink-100 to-purple-100 rounded-xl flex items-center justify-center mr-3 group-hover:scale-110 transition-transform duration-300">
                              <span className="w-2.5 h-2.5 bg-gradient-to-r from-pink-500 to-purple-500 rounded-full animate-pulse"></span>
                            </div>
                            <span className="text-gray-700 font-medium group-hover:text-pink-600 transition-colors duration-300">{feature}</span>
                          </li>
                        ))}
                      </ul>
                    </div>
                    <div className="flex flex-col sm:flex-row justify-between items-center gap-4 border-t border-pink-100 pt-6 sm:pt-8">
                      <div className="flex items-center space-x-2 text-gray-500 order-2 sm:order-1">
                        <span className="w-2 h-2 bg-green-500 rounded-full animate-pulse"></span>
                        <span className="text-sm">Disponibile per il tuo evento</span>
                      </div>
                      <a
                        href={`https://wa.me/+393274517331?text=Ciao! Sono interessato/a all'attrazione "${attractions[selectedAttraction].title}". Vorrei maggiori informazioni.`}
                        target="_blank"
                        rel="noopener noreferrer"
                        onClick={closeModal}
                        className="w-full sm:w-auto inline-flex items-center justify-center px-6 sm:px-8 py-3 sm:py-4 text-base sm:text-lg font-semibold rounded-full text-white bg-gradient-to-r from-pink-600 to-purple-600 hover:from-pink-700 hover:to-purple-700 transform hover:scale-102 transition-all duration-300 shadow-lg hover:shadow-xl group relative overflow-hidden order-1 sm:order-2"
                      >
                        <span className="absolute inset-0 bg-gradient-to-r from-white/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 transform -skew-x-45"></span>
                        Contattaci su WhatsApp
                        <svg 
                          className="w-5 h-5 ml-2 transform group-hover:translate-x-1 transition-transform duration-300" 
                          viewBox="0 0 24 24" 
                          fill="none" 
                          stroke="currentColor" 
                          strokeWidth="2" 
                          strokeLinecap="round" 
                          strokeLinejoin="round"
                        >
                          <path d="M5 12h14M12 5l7 7-7 7" />
                        </svg>
                      </a>
                    </div>
                  </div>
                </div>
                <div className="mt-12 bg-gradient-to-br from-pink-50/50 to-purple-50/50 p-6 sm:p-8 rounded-2xl border border-pink-100/50 shadow-inner">
                  <h4 className="text-2xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-pink-600 to-purple-600 mb-6">
                    Galleria Fotografica
                    <span className="ml-2 text-sm font-normal text-gray-500">
                      ({currentImageIndex + 1}/{attractions[selectedAttraction].images.length})
                    </span>
                  </h4>
                  
                  {/* Main Image with enhanced animation */}
                  <div className="relative group transition-all duration-500">
                    <div className="aspect-[16/9] overflow-hidden rounded-2xl shadow-lg bg-gradient-to-br from-pink-50 to-purple-50">
                      <img
                        src={attractions[selectedAttraction].images[currentImageIndex]}
                        alt={`${attractions[selectedAttraction].title} - Foto ${currentImageIndex + 1}`}
                        className="w-full h-full object-cover transform-gpu transition-all duration-700 group-hover:scale-105"
                        loading="lazy"
                      />
                      <div className="absolute inset-0 bg-gradient-to-t from-black/30 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-all duration-500"></div>
                    </div>
                    
                    {/* Navigation Buttons */}
                    <button
                      onClick={() => setCurrentImageIndex((prev) => (prev === 0 ? attractions[selectedAttraction].images.length - 1 : prev - 1))}
                      className="absolute left-4 top-1/2 -translate-y-1/2 p-3 rounded-full bg-white/90 backdrop-blur-sm hover:bg-white text-gray-800 hover:text-pink-600 transition-all duration-500 shadow-lg hover:shadow-xl opacity-0 group-hover:opacity-100 transform -translate-x-4 group-hover:translate-x-0 hover:scale-110"
                    >
                      <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 19l-7-7 7-7" />
                      </svg>
                    </button>
                    
                    <button
                      onClick={() => setCurrentImageIndex((prev) => (prev === attractions[selectedAttraction].images.length - 1 ? 0 : prev + 1))}
                      className="absolute right-4 top-1/2 -translate-y-1/2 p-3 rounded-full bg-white/90 backdrop-blur-sm hover:bg-white text-gray-800 hover:text-pink-600 transition-all duration-500 shadow-lg hover:shadow-xl opacity-0 group-hover:opacity-100 transform translate-x-4 group-hover:translate-x-0 hover:scale-110"
                    >
                      <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5l7 7-7 7" />
                      </svg>
                    </button>
                  </div>
                  
                  {/* Enhanced Thumbnails */}
                  <div className="mt-6 grid grid-cols-4 gap-4">
                    {attractions[selectedAttraction].images.map((_, index) => (
                      <button
                        key={index}
                        onClick={() => setCurrentImageIndex(index)}
                        className={`relative aspect-[16/9] overflow-hidden rounded-lg transition-all duration-300 ${
                          currentImageIndex === index
                            ? 'ring-2 ring-pink-600 ring-offset-2 scale-[1.05] shadow-lg'
                            : 'hover:ring-2 hover:ring-pink-400 hover:ring-offset-2 hover:scale-[1.02]'
                        }`}
                        aria-label={`Vai alla foto ${index + 1}`}
                      >
                        <img
                          src={attractions[selectedAttraction].images[index]}
                          alt={`${attractions[selectedAttraction].title} - Miniatura ${index + 1}`}
                          className={`w-full h-full object-cover transition-all duration-300 ${
                            currentImageIndex === index
                              ? 'brightness-100'
                              : 'brightness-75 hover:brightness-100 hover:transform hover:scale-105'
                          }`}
                          loading="lazy"
                        />
                        <div className={`absolute inset-0 border-2 rounded-lg transition-colors duration-300 ${
                          currentImageIndex === index
                            ? 'border-pink-600'
                            : 'border-transparent'
                        }`}></div>
                        <div className="absolute inset-0 bg-gradient-to-t from-black/20 via-transparent to-transparent opacity-0 hover:opacity-100 transition-opacity duration-300"></div>
                      </button>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default Gallery